import PostStore from "../../../services/Store"

function getChannels() {
    return PostStore.getChannels()
}

export {getChannels}
